export function formatCycleFileTime(filename) {
  if (!filename) {
    return "—";
  }
  return new Date(
    filename.slice(0, 19).replaceAll("_", ":") + ".000Z",
  ).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatNextWakeupDatetime(nextWakeupDatetime) {
  if (!nextWakeupDatetime) {
    return "—";
  }

  const currentDate = new Date();
  const wakeupDate = new Date(nextWakeupDatetime);
  const optionsTime = { hour: "2-digit", minute: "2-digit" };

  if (wakeupDate.toDateString() === currentDate.toDateString()) {
    return wakeupDate.toLocaleTimeString([], optionsTime);
  }

  const optionsDate = { weekday: "long" };
  const dayName = wakeupDate.toLocaleDateString(undefined, optionsDate);
  return `${dayName}, ${wakeupDate.toLocaleTimeString([], optionsTime)}`;
}

export function getRecentCyclesForDisplay(cycleEntries, count = 3) {
  return (cycleEntries || [])
    .slice()
    .sort((a, b) => String(b.name).localeCompare(String(a.name)))
    .slice(0, count);
}
